import script from "./BaseJobBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseJobBadge.vue?vue&type=script&setup=true&lang=ts"

import "./BaseJobBadge.vue?vue&type=style&index=0&id=3e0fcccf&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e0fcccf"]])

export default __exports__